import React from 'react'
import {
  TimelineExtensionBlock,
  TimelinePermitWarningsBlock,
  TimelineTransferBlock,
} from '@common/Timeline'
import { localizedStrings } from '@core/strings'
import { AuditResult } from '@core/entities/audit/AuditResult'
import { TimelineApprovalNominationBlock } from './TimelineApprovalNominationBlock'

type ComponentProps = {
  auditResult: AuditResult
}

export const TimelinePermitBlocks: React.FC<ComponentProps> = ({
  auditResult,
}) => {
  return (
    <>
      {auditResult.hasWarnings() && (
        <TimelinePermitWarningsBlock auditResult={auditResult} />
      )}
      {auditResult.isExtendingPermit() && (
        <TimelineExtensionBlock
          extensionEndsOn={auditResult.metadata?.permitExtensionEndsOn}
          previousEndsOn={auditResult.metadata?.permitPreviousEndsOn}
        />
      )}
      {auditResult.isShorteningPermit() && (
        <TimelineExtensionBlock
          title={localizedStrings.shortenInformation}
          extensionEndsOn={auditResult.metadata?.permitShortenedEndsOn}
          previousEndsOn={auditResult.metadata?.permitPreviousEndsOn}
        />
      )}
      {auditResult.isTransferring() && (
        <TimelineTransferBlock
          title={localizedStrings.transferInformation}
          user={auditResult.user}
          transferReceiver={auditResult.metadata?.transferReceiver}
          projectId={auditResult.project?.id}
          organisationId={auditResult.organisation?.id}
        />
      )}
      {auditResult.isNominatingApprovers() && (
        <TimelineApprovalNominationBlock
          nominatedApprovers={auditResult.metadata?.nominatedApprovers}
          nominatedForApproval={auditResult.metadata?.nominatedForApproval}
        />
      )}
    </>
  )
}
